<template>
  <overlay class="m-red-envelope" :show.sync="visible" @click="close">
    <div class="wrapper red-envelope" @click.stop="">
      <div class="red-header">
        <img src="@/assets/images/red-head.png" alt="" />
      </div>
      <div class="info">
        <el-avatar shape="square" icon="el-icon-user" :src="info.avatar"></el-avatar>
        <div class="txt">
          <p>{{ info.company }}</p>
          <p class="name">{{ info.name }}</p>
        </div>
      </div>
      <pre class="content" @click="detail({ path: 'detail', query: { id: info.msgId } })">{{ info.txt }}</pre>
      <el-image v-if="info.imgs" :src="info.imgs[0]">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <p class="amount-box" v-if="this.cacheInfo === info.redEnvelopeId || info.getAmount || info.redEnvelopeOver">
        <span v-if="info.getAmount">恭喜您抢到了 {{ info.getAmount }}元</span>
        <span v-else>
          很抱歉，红包已被抢完
        </span>
        <span @click="detail({ path: '/redDetail', query: { id: info.redEnvelopeId } })" style="font-size: 12px; cursor: pointer;">查看详情</span>
      </p>
      <span v-else class="open-btn" @click.stop="openHandle">
        <i v-if="loading" class="el-icon-loading"></i>
        <span v-else>拆</span>
      </span>
    </div>
  </overlay>
</template>
<script>
import { Overlay } from "vant";
import Pay from "@/api/pay";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    detail({ path, query }) {
      if (this.$route.name === "Home") {
        this.$store.commit("setChatScroll");
      }
      this.$emit("update:visible", false);
      this.$router.push({ path, query });
    },
    async openHandle() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const result = await Pay.redWars(this.info.redEnvelopeId);
      if (result.Status === 2) {
        this.info.redEnvelopeOver = true;
        this.$store.commit("addRedList", this.info);
      }
      if (result.Status === 1) {
        this.$store.dispatch("getChatInfo");
        this.info.getAmount = result.Amount;
        this.$store.commit("addRedList", this.info);
      }
      this.loading = false;
    },
    close() {
      this.$emit("update:visible", false);
    }
  },
  computed: {
    cacheInfo() {
      const list = this.$store.state.redList;
      const index = list.findIndex(item => item.redEnvelope === this.info.redEnvelope);
      return index === -1 ? null : list[index];
    }
  },
  components: { Overlay },
  props: {
    info: Object,
    visible: Boolean
  }
};
</script>
<style lang="scss">
.m-red-envelope {
  width: 100%;
  height: 100%;
  z-index: 9999 !important;
  .wrapper {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
  }
  .info {
    padding: 16px 20px;
    color: #fff;
    display: flex;
    .el-avatar {
      border: 1px solid #fff;
    }
    .txt {
      margin-left: 8px;
      font-size: 12px;
      display: inline-flex;
      flex-direction: column;
    }
    .name {
      font-size: 12px;
    }
  }
  .content {
    cursor: pointer;
    padding: 0 20px;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  .el-image {
    display: block;
    width: 50%;
    margin: 10px auto;
    border: 1px solid #fff;
  }
  .red-envelope {
    position: relative;
    background-color: #f44336;
    padding-bottom: 32px;
    width: 75%;
    border-radius: 10px;
    overflow: hidden;
    .red-header {
      width: 100%;
      img {
        display: inline-block;
        width: 100%;
      }
    }
    .open-btn {
      cursor: pointer;
      display: flex;
      margin: 40px auto 0 auto;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      font-size: 20px;
      font-weight: bold;
      background-color: #ffd740;
    }
    .amount-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 12px;
      margin: 16px 24px 0px 24px;
      font-weight: bold;
      font-size: 14px;
      background-color: #ffd740;
      border-radius: 5px;
      color: #5d4037;
    }
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
}
</style>
